import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[appNumericInputFloat]'
})
export class NumericInputDirectiveWithFloat {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // @HostListener('input', ['$event']) onInputChange(event: any) {
  //   const initialValue = this.el.nativeElement.value;
  //   const sanitizedValue = initialValue.replace(/[^0-9.+]/g, ''); // Remove non-numeric characters
  //   if (initialValue !== sanitizedValue) {
  //     this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
  //     event.stopPropagation();
  //   }
  // }
  @HostListener('input', ['$event'])
  onInputChange(event: any) {
      const initialValue = this.el.nativeElement.value;
  
      // Allow only numbers, one decimal (.), and plus (+) at the start
      let sanitizedValue = initialValue.replace(/[^0-9.]/g, ''); // Allow numbers & decimal only
  
      // Ensure only one decimal point is allowed
      const decimalCount = (sanitizedValue.match(/\./g) || []).length;
      if (decimalCount > 1) {
          sanitizedValue = sanitizedValue.replace(/\.(?=.*\.)/g, ''); // Remove all except the first .
      }
  
      // Ensure "+" is only at the start
      if (initialValue.startsWith('+')) {
          sanitizedValue = '+' + sanitizedValue.replace(/\+/g, '');
      } else {
          sanitizedValue = sanitizedValue.replace(/\+/g, ''); // Remove all + if it's not at the start
      }
  
      // Apply the sanitized value back to the input
      if (initialValue !== sanitizedValue) {
          this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
          event.stopPropagation();
      }
  }
  


}
